module.exports = __webpack_public_path__ + "static/media/Purpose_23.c14a8e23.png";